import { defineComponent as _defineComponent } from 'vue';
import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-1a20b3a2"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "dropDownMainContainer" };
const _hoisted_2 = ["id"];
const _hoisted_3 = { class: "selectedOptionText" };
const _hoisted_4 = ["id", "onClick"];
const _hoisted_5 = ["id"];
import { ChevronDownIcon } from '@gohighlevel/ghl-icons/24/outline';
import { onMounted, ref } from 'vue';
// const props = defineProps(['value', 'options', 'id', 'label', 'handleChange'])
export default /*#__PURE__*/ _defineComponent({
    __name: 'UIDropdown',
    props: {
        value: Object,
        id: String,
        options: Array,
        label: String,
        handleChange: Function,
    },
    setup(__props) {
        const props = __props;
        const showOptions = ref(false);
        const dropDownOptions = props.options
            ? props.options
            : [{ value: 'OptionsUnavailable', label: 'Options unavailable' }];
        const wrapperRef = ref(null);
        // Function to hide/show the dropdown options
        const toggleOptions = () => {
            showOptions.value = !showOptions.value;
        };
        // Function to be called on click of option from dropdown
        const selectOption = option => {
            if (option !== 'OptionsUnavailable') {
                props.handleChange(option);
            }
            showOptions.value = false;
        };
        onMounted(() => {
            // Function to handle clicks outside the component
            const handleClickOutside = event => {
                // Check if 'wrapperRef' is defined and if the clicked target is outside the component
                if (wrapperRef.value && !wrapperRef.value.contains(event.target)) {
                    // If the click is outside, hide the options
                    showOptions.value = false;
                }
            };
            // Add an event listener to the document to listen for 'mousedown' events
            document.addEventListener('mousedown', handleClickOutside);
            // Return a cleanup function that removes the event listener when the component is unmounted
            return () => {
                document.removeEventListener('mousedown', handleClickOutside);
            };
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", {
                    class: "dropDownMain",
                    ref_key: "wrapperRef",
                    ref: wrapperRef
                }, [
                    _createElementVNode("div", {
                        class: "selectedOption",
                        onClick: toggleOptions,
                        id: __props.id
                    }, [
                        _createElementVNode("div", null, [
                            (__props.value.icon)
                                ? (_openBlock(), _createBlock(_resolveDynamicComponent(__props.value.icon), {
                                    key: 0,
                                    class: "w-6 h-6 text-gray-500"
                                }))
                                : _createCommentVNode("", true),
                            _createElementVNode("p", _hoisted_3, _toDisplayString(__props.value && __props.value.label ? __props.value.label : __props.label), 1)
                        ]),
                        _createVNode(_unref(ChevronDownIcon), { class: "w-6 h-6 text-gray-500" })
                    ], 8, _hoisted_2),
                    _createElementVNode("ul", {
                        class: _normalizeClass(showOptions.value ? 'dropDownList' : 'hiddenDropDownList')
                    }, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(dropDownOptions), (option, index) => {
                            return (_openBlock(), _createElementBlock("li", {
                                key: option.value + '-div'
                            }, [
                                (_openBlock(), _createElementBlock("div", {
                                    id: option.value + '-drop-down-option',
                                    key: index,
                                    onClick: ($event) => (selectOption(option)),
                                    class: "flex flex-row gap-2 items-center"
                                }, [
                                    (option.icon)
                                        ? (_openBlock(), _createBlock(_resolveDynamicComponent(option.icon), {
                                            key: 0,
                                            class: "w-4 h-4 text-gray-500"
                                        }))
                                        : _createCommentVNode("", true),
                                    (_openBlock(), _createElementBlock("li", {
                                        id: __props.id + '-' + option.value + '-drop-down-option-li',
                                        key: __props.id + option + '-li',
                                        class: _normalizeClass('dropDownOption' +
                                            (__props.value.value === option.value ? ' dropDownSelectedOption' : ''))
                                    }, _toDisplayString(option.label), 11, _hoisted_5))
                                ], 8, _hoisted_4))
                            ]));
                        }), 128))
                    ], 2)
                ], 512)
            ]));
        };
    }
});
